import React from "react";

function OurStory() {
  return (
    <section>
      <div className="story container">
        <div className="row justify-content-between align-items-center ">
          <div className="col-md-7 content__mid">
            <h1 className="mb-4">OUR NFT STORY</h1>

            <p>
              We are a 5000 NFT collection searching to help save baby turtles.
              We will donate a part of the money towards them.
            </p>
          </div>

          <div className="col-md-4 mobile__screen">
            <div className="main_div32">
              <img src="/Assets/a.png" alt="" className="w-100 content__img" />
              <div className="outer__div2 "></div>
              <div className="outer__div1 "></div>
              <div className="outer__div3 "></div>
              <div className="outer__div4 "></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OurStory;
